import { CancelScheduleSendOutlined, DeleteOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { SvbrgIntakeStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { useIntakeRequestActions } from '~/hooks';

import { GridActionType, STATUS_GRID_ACTION_MAP } from './IntakeGridAction.types';

const ACTION_ICON_MAP = {
  [GridActionType.DISCARD]: <DeleteOutlined fontSize="small" />,
  [GridActionType.CANCEL]: <CancelScheduleSendOutlined fontSize="small" />,
};

interface IntakeGridActionProps {
  id: string;
  status: SvbrgIntakeStatus;
}

export const IntakeGridAction = ({ id, status }: IntakeGridActionProps) => {
  const action = STATUS_GRID_ACTION_MAP[status];
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestAction' });
  // improper refetch mechanism that's already in place
  const { loading, ...actions } = useIntakeRequestActions();

  if (!action) {
    return null;
  }

  return (
    <Tooltip title={t(`${action}.title`)} arrow placement="top" key={action}>
      <GridActionsCellItem
        icon={ACTION_ICON_MAP[action]}
        label={`${action}.title`}
        onClick={() => {
          actions[action](id);
        }}
      />
    </Tooltip>
  );
};
